import { ServerMediaAsset } from '@/lib/janitsjar/Product';
import SceneryImage from '@/components/newImageCarousel/renderers/SceneryImage';
import ProductImage from '@/components/newImageCarousel/renderers/ProductImage';
import VideoThumbnail from '@/components/newImageCarousel/renderers/VideoThumbnail';

type CarouselSlideProps = {
  media: ServerMediaAsset;
  activeSlide?: boolean;
  onClick?: () => void;
};

export default function CarouselSlide({
  media,
  activeSlide = false,
  onClick,
}: CarouselSlideProps) {
  const { type, role } = media;

  const Component =
    type === 'video' ? (
      <VideoThumbnail media={media} />
    ) : role?.startsWith('miljo') ? (
      <SceneryImage media={media} />
    ) : (
      <ProductImage media={media} />
    );

  return (
    <div
      className="embla__slide min-w-0 flex-none w-full h-full cursor-pointer"
      onClick={onClick}
    >
      {Component}
    </div>
  );
}
